import address from './address.schema';
import defaultSchema from './default.schema';

export default {
  ...defaultSchema,
  title: 'Punkt odbioru',
  type: 'object',
  allOf: [
    address,
    {
      properties: {
        name: {
          title: 'Nazwa punktu odbioru',
          type: 'string',
          fieldRequired: true,
          maxLength: 500
        },
        description: {
          title: 'Opis',
          type: 'string',
          fieldRequired: false
        }
      }
    }
  ]
};
